import React from 'react';
export function SolutionIntro() {
  return <section className="section" data-id="element-148">
      <h2 className="section-h2" data-id="element-149">
        No es un curso. No es coaching. Es un bundle de preparación.
      </h2>

      <p className="section-lead" data-id="element-150">
        A.R.M.O.N.Y. es un sistema de preparación curado por el equipo
        Dermaclinic — cuatro recursos diseñados para que entres a una decisión
        corporal de cinco cifras con cabeza fría. Quita el ruido, ordena las
        preguntas correctas, y mapea — fase por fase — qué esperar antes,
        durante y después del procedimiento. Ni ansiedad, ni presión de cierre,
        ni "lo que me dijo una amiga".
      </p>

      <div className="solution-callout" data-id="element-151">
        <p data-id="element-152">Cuatro recursos. Seis fases. Un solo bundle.</p>
      </div>
    </section>;
}